/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 18:40:17
 * @LastEditors: Andy
 * @LastEditTime: 2022-11-23 12:10:45
 */
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@main/modules/login/views/login.vue')
  },
  {
    path: '/login/password_find',
    name: 'loginPasswordFind',
    component: () => import('@main/modules/login/views/passwordFind.vue')
  },
  {
    path: '/login/nick_find',
    name: 'loginNickFind',
    component: () => import('@main/modules/login/views/nickFind.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@main/modules/login/views/register.vue')
  },
]
export default routes
